import React from 'react'
import {CI2} from '../../utils/calendar'
import SupplierElement from '../debit/rowelements/supplierelement'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {Loader} from '../../utils/misc'
import moment from 'moment'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import _ from 'lodash'
export default class Receipt extends React.Component {

  constructor(props){

    super(props)
    this.state = {loading:true, purchaseOptions:[], loadingPurchases:false, supplier_total_due: 0,
      payment:{ amount:"", date:moment(new Date()).format(), mode:"cash", reference:"", notes:"", is_payment:true }
      }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getPayment = this.getPayment.bind(this)
    this.getSupplierPurchases = this.getSupplierPurchases.bind(this)
    this.handleSupplierChange = this.handleSupplierChange.bind(this)
    this.handlePurchaseChange = this.handlePurchaseChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.deleteReceipt = this.deleteReceipt.bind(this)
    this.renderOption = this.renderOption.bind(this)


  }

  handleDateChange(da) {
    this.modifyItemState('date', da)
  }
  handleInputChange(e) {
    this.modifyItemState(e.target.name, e.target.value)
  }
  handleSupplierChange(supplier) {
    this.setState({loadingPurchases:true,
                    purchaseOptions:[],
                    payment:{ amount:"", date:moment(new Date()).format(), mode:"cash", reference:"", notes:"", is_payment:true }})
    this.modifyItemState('supplier', supplier)
    this.modifyItemState('purchase', null)
    if(supplier && supplier.id) {
      this.getSupplierPurchases(supplier.id).then((response)=>{
        if(response.status===200) {
          let purchases = response.data.purchases
          let payments = response.data.payments
          let totalPurchases = _.sum(_.map( purchases, purchase=> {

                return parseFloat(purchase.total)

          }))
          let totalPayments = _.sum(_.map(payments, payment=>{
             return parseFloat(payment.amount)
          }))
          let totalDue = parseFloat(totalPurchases-totalPayments).toFixed(2)
          this.setState({supplier_total_due: totalDue, supplier_total_purchases:totalPurchases, supplier_total_payments:totalPayments})
          this.modifyItemState('amount', totalDue)
          this.setState({purchaseOptions: response.data.purchases, loadingPurchases:false})

        }
      }).catch((err)=>{
        this.setState({loadingPurchases:false})
      })
    }
  }
  handlePurchaseChange(purchase) {
    let due = this.getPurchaseDue(purchase)
    this.modifyItemState('amount', due)
    this.modifyItemState('purchase', purchase)
  }


  modifyItemState(key, value) {
    this.setState({errors: undefined})
          let currentRetn = this.state.payment
          currentRetn[key] = value
          this.setState({
            payment:currentRetn
         });
  }


  componentDidMount() {
    let params = this.props.match.params
    if(typeof params.payment_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Payment " + this.props.match.params.payment_id
      this.getPayment(this.props.match.params.payment_id).then((response)=>{
        if(response.status===200) {
          console.log(response.data.payment);
          this.setState({payment: response.data.payment, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Add Payment "
        this.setState({loading:false})
    }
  }

  getPayment(payment_id) {
    return axios({
      url: '/get_payment/?id='+payment_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  getSupplierPurchases(supplier_id) {
    return axios({
      url: '/list_purchases/?require_payments=true&supplier_id='+supplier_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  deleteReceipt() {

    axios({
      url: '/delete_payment/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.payment
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Payment successfully")
        setTimeout(()=>{
          this.props.history.push("/payments/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }


    submit(e) {
      this.setState({'submitting':true})

      let apiurl
      if(this.state.mode ==="edit") {
        apiurl  = "/update_payment/"
      }
      else {
        apiurl  = "/create_new_payment/"
      }

      axios({
        url: apiurl,
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.payment
      }).then((response)=> {
        this.setState({'submitting':false})
        if(response.status === 200) {
          if(this.state.mode === "edit") {
              NotificationManager.success("Updated Receipt successfully")
          }
          else {
            NotificationManager.success("Created Receipt successfully")
          }

          setTimeout(()=>{
            this.props.history.push("/payments/")
          }, 700)

        }
      }).catch((err)=> {
        this.setState({'submitting':false})
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
          this.setState({errors: err.response.data.errors})
        }

      })
    }

  renderOption(option) {
      let due = this.getPurchaseDue(option)
      return <span>Purchase {option.serial} Due: {due} </span>
  }

  getPurchaseDue(purchase) {

    if(typeof purchase !== "undefined" && purchase !== null) {
      let purchase_payment_set = purchase.payment_set
      if(purchase_payment_set !== null && purchase_payment_set.length > 0) {

          let paid = _.sum(_.map(purchase_payment_set, pp => {
                  return parseFloat(pp.amount)
          }))

          return parseFloat(parseFloat(purchase.total) - paid).toFixed(2)
      }
      else {
        return parseFloat(purchase.total).toFixed(2)
      }
    }
    else {
      return 0;
    }

  }


  render() {

    let payment = this.state.payment

    let purchaseOptions = this.state.purchaseOptions

    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>

    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }

    let supplier = <SupplierElement pretn={payment} onAddCallback={this.handleSupplierChange} />

    let amountError
    if(typeof this.state.errors !== "undefined") {

       let errors = this.state.errors
       if(typeof errors.amount !== "undefined") {
         amountError = <p className="text-danger">{errors.amount[0]}</p>
       }

    }
    let calculationMsg
    if(this.state.loadingPurchases) {
      calculationMsg = <span className="text-muted">Calculating due amount..</span>
    }
    else {
      calculationMsg = <span className="text-muted">Total Purchases: {this.state.supplier_total_purchases}, Total Payments: {this.state.supplier_total_payments}, Net Due Amount: {this.state.supplier_total_due}</span>
    }


    let form = <div className="form-horizontal">
          <div className="form-group">
            <div className="col-sm-2">
            Supplier
            </div>
            <div className="col-sm-10">
            {supplier}
            {calculationMsg}
            </div>

          </div>


          <div className="form-group">
            <div className="col-sm-2">
            Supplier Purchase
            </div>
            <div className="col-sm-10">
            <Select multi={false} onChange={this.handlePurchaseChange} valueRenderer={this.renderOption} openOnFocus={true}
            options={purchaseOptions} optionRenderer={this.renderOption} value={payment.purchase} />
            </div>

          </div>




          <div className="form-group">
          <div className="col-sm-2">
          Amount (&#8377;)
          </div>
          <div className="col-sm-10">
          <input  type="text" name="amount" value={payment.amount} onChange={this.handleInputChange} className="form-control input-sm" required />
          {amountError}
          </div>
          </div>

          <div className="form-group">
          <div className="col-sm-2">
          Date

          </div>

          <div className="col-sm-10">
          <CI2 applyDate={this.handleDateChange} date={payment.date} />
          </div>
          </div>

          <div className="form-group">

          <div className="col-sm-2">
          Payment Mode
          </div>
            <div className="col-sm-10">
            <select name="mode" value={payment.mode} className="form-control input-sm" onChange={this.handleInputChange}>
              <option value="cash" >CASH</option>
              <option value="card">CARD</option>
              <option value="cheque">CHEQUE</option>
              <option value="banktransfer">BANK TRANSFER</option>
              <option value="others">Others</option>
            </select>
            </div>
          </div>




          <div className="form-group">
          <div className="col-sm-2">
          Reference

          </div>

          <div className="col-sm-10">

          <input  type="text" name="reference" value={payment.reference} onChange={this.handleInputChange} className="form-control input-sm" />
          </div>
          </div>


          <div className="form-group">
          <div className="col-sm-2">
          Notes
          </div>
           <div className="col-sm-10">
          <textarea name="notes" className="form-control input-sm" value={payment.notes} onChange={this.handleInputChange}></textarea>
           </div>
          </div>

      </div>



      let pageHeader
      let deleteRetnBtn
      if(!this.state.loading) {

        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Payment "}</h3>
          deleteRetnBtn = <button className="btn btn-sm btn-danger" onClick={this.deleteReceipt}>Delete Receipt</button>
        }
        else {
          pageHeader =  <h3>Add Payment</h3>
        }

        return <div className="container-fluid">
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li className="pull-right">{deleteRetnBtn}</li>
              </ul>
        </section>
                  <div className="row">
                  <div className="col-md-6">
                  {form}
                  <div className="form-action-group text-right">
                  {submitButton}
                  </div>
                  </div>
                  </div>


    </div>
      }
      else {
        return <div>
            <Loader />
        </div>
      }


  }
}



// WEBPACK FOOTER //
// ./src/components/payment/addpayment.js